<template>
    <v-container grid-list-xl fluid>
        <v-layout row wrap>
            <v-flex lg12>
                <v-card>
                    <hpo-filter :headers="filter_headers" :viewName="viewName" v-on:applyFilter="applyFilter" v-on:quickFilter="quickFilter"></hpo-filter>
                    <v-layout row wrap v-if="!order_type">
                        <v-flex lg12>
                            <v-btn class="ml-3" small @click="exportExcel">
                                <v-icon class="mr-3" color="#0f7896">fa fa-file-excel-o</v-icon>  Xuất excel
                            </v-btn>
                            <v-btn class="ml-3" small @click="exportExcelBuy">
                                <v-icon class="mr-3" color="#0f7896">fa fa-file-excel-o</v-icon>  Hàng cần mua
                            </v-btn>
                        </v-flex>
                    </v-layout>
                    <v-data-table :headers="headers" :items="items" :options.sync="pagination" :server-items-length="total_rows" :footer-props="items_per_page" :must-sort="true" :loading="loading" :mobile-breakpoint="100" item-key="id" show-select v-model="selected">
                        <template v-slot:item="{ item, isSelected, select }">
                            <tr :active="isSelected" @click="select(!isSelected)">
                                <td>
                                    <v-checkbox primary hide-details :input-value="isSelected"></v-checkbox>
                                </td>
                                <td>{{ item.id }}</td>
                                <td>{{ item.meimei_code }}</td>
                                <td>{{ item.china_order_code }}</td>
                                <td>{{ item.created_at | display_date }}</td>
                                <td><img :src="'/'+item.path" alt="" style="height: 56px; width: 56px;"></td>
                                <td>{{ item.customer_first_name }} {{ item.customer_last_name }}</td>
                                <td class="text-start" v-bind:style="{'color': display_color(item.status, order_status)}" >{{ item.status | display_value(order_status) }}</td>
                                <td class="text-start">{{ item.shipment_status | display_value(order_shipment_status) }}</td>
                                <td class="text-start">
                                    <h4><a target="_blank" :href="'/quan-ly-san-pham/san-pham-ban/' + item.product_id">{{ item.name }}</a></h4>
                                    <h4>{{ item.product_code }}</h4>
                                    <h4><b>SL đặt:</b><span class="text-red">{{ item.qty | currency }}</span></h4>
                                    <h4><b>SL mua:</b><span class="text-red">{{ item.qty_bought | currency }}</span></h4>
                                    <h4><b>SL về:</b><span class="text-red">{{ item.qty_instore | currency }}</span></h4>
                                </td>
                                <td class="text-start">
                                    <template v-if="item.options && item.options.length > 0">
                                        <ul>
                                            <li v-for="op in item.options" :key="op.order_product_id">
                                                {{ op.option_label }} (SL: <span class="text-red">{{ op.qty }}</span>)
                                            </li>
                                        </ul>
                                    </template>
                                </td>
                                <td class="text-end">{{ item.total | currency }}</td>
                                <td class="text-start">{{ item.admin_note }}</td>
                                <td class="text-center">               
                                    <v-icon medium class="mr-2" @click="openItem(item)">edit</v-icon>
                                </td>
                            </tr>
                        </template>
                    </v-data-table>
                </v-card>
            </v-flex>
        </v-layout>
        <v-dialog v-model="dialogItem" max-width="800px">
          <v-card>
            <v-card-title>
              <span class="title">Chi tiết đơn hàng</span>
            </v-card-title>
            <v-card-text>
              <v-container grid-list-md pa-0>
                <v-layout row wrap>
                    <v-flex lg12>
                        <v-autocomplete label="Khách hàng" v-model="currentItem.customer_id" :items="customers" :item-text="getCustomerText" item-value="id" class="input-group--focused" :disabled="currentItem.id > 0"></v-autocomplete>
                    </v-flex>
                    <v-flex lg12 v-if="!currentItem.id">
                        <v-autocomplete label="Sản phẩm" v-model="currentItem.product_id" :items="products" :item-text="getProductText" item-value="id" class="input-group--focused" @change="onSelectedProduct"></v-autocomplete>
                    </v-flex>
                    <v-flex lg12 v-else-if="selectedItemList">
                        Sản phẩm: <h4>{{ selectedItemList.product_code }} ({{ selectedItemList.name }})</h4>
                    </v-flex>
                    <v-flex lg12 v-if="currentItem.id > 0">
                        <v-checkbox v-model="isUpdateProp" label="Cập nhật thuộc tính" class="input-group--focused"></v-checkbox>
                    </v-flex>
                    <v-flex lg12 v-if="!currentItem.id || isUpdateProp">
                        <div class="product_option" v-if="selectedProduct.options && selectedProduct.options.length > 0">
                            <v-layout row wrap v-for="op in selectedProduct.options" :key="op.id">
                                <v-flex lg2 md2 sm12>
                                    <h4>{{ op.name }}</h4>
                                </v-flex>
                                <v-flex lg10 md10 sm12 v-if="op.position == 0">
                                    <ul class="list-inline-1">
                                        <li v-for="val in op.option_values" :key="val.id" v-bind:class="{ 'has_image': op.has_image && val.path, 'active': val.id == selectedFirstOption.id, 'choised': getFirstOptionQty(val.id) > 0}"  @click="selectedFirstOption = val">
                                            <img :src="'/'+val.path" alt="Option image" v-if="op.has_image && val.path">
                                            <p v-else>{{ val.label }}</p>
                                        </li>
                                    </ul>
                                </v-flex>
                                <v-flex lg10 md10 sm12 v-else>
                                    <v-data-table :headers="op_headers" :items="op.option_values" disable-pagination hide-default-footer :mobile-breakpoint="100">
                                        <template v-slot:item="{ item }">
                                            <tr v-bind:class="{'row-qty': getOrderOption(selectedFirstOption.id, item.id) > 0}">
                                                <td>
                                                    <label for="qty" :name="'op_'+selectedFirstOption.id + '_'+ item.id">{{ (selectedFirstOption ? selectedFirstOption.label + ' - ' : '') + item.label }}</label>
                                                </td>
                                                <td>
                                                    <v-minusplusfield :min="0" :max="1000000" :value="getOrderOption(selectedFirstOption.id, item.id)" @input="event => updateOrderOption(selectedFirstOption.option_id, selectedFirstOption.id, item.option_id, item.id, event)"></v-minusplusfield>
                                                </td>
                                                <td v-if="currentItem.id > 0" v-bind:class="{'cell-qty': getOrderOption(selectedFirstOption.id, item.id, 'qty_not_bought') > 0}">
                                                    <v-minusplusfield :min="0" :max="1000000" :value="getOrderOption(selectedFirstOption.id, item.id, 'qty_not_bought')" @input="event => updateOrderOption(selectedFirstOption.option_id, selectedFirstOption.id, item.option_id, item.id, event, 'qty_not_bought')"></v-minusplusfield>
                                                </td>
                                                <td v-if="currentItem.id > 0" v-bind:class="{'cell-qty': getOrderOption(selectedFirstOption.id, item.id, 'qty_not_instore') > 0}">
                                                    <v-minusplusfield :min="0" :max="1000000" :value="getOrderOption(selectedFirstOption.id, item.id, 'qty_not_instore')" @input="event => updateOrderOption(selectedFirstOption.option_id, selectedFirstOption.id, item.option_id, item.id, event, 'qty_not_instore')"></v-minusplusfield>
                                                </td>
                                            </tr>
                                        </template>
                                    </v-data-table>
                                    <!-- <ul class="list-inline-2">
                                        <li v-for="val in op.option_values" :key="val.id" class="number-picker" v-bind:class="{'choised': getOrderOption(selectedFirstOption.id, val.id) > 0}">
                                            <label for="qty" :name="'op_'+selectedFirstOption.id + '_'+ val.id">{{ (selectedFirstOption ? selectedFirstOption.label + ' - ' : '') + val.label }}</label>
                                            <v-minusplusfield :min="0" :max="1000000" :value="getOrderOption(selectedFirstOption.id, val.id)" @input="event => updateOrderOption(selectedFirstOption.option_id, selectedFirstOption.id, val.option_id, val.id, event)"></v-minusplusfield>
                                        </li>
                                    </ul> -->
                                </v-flex>
                            </v-layout>
                            <v-layout row wrap v-if="selectedProduct.options.length == 1 && selectedFirstOption">
                                <v-flex lg2 md2 sm12>
                                </v-flex>
                                <v-flex lg10 md10 sm12>
                                    <v-data-table :headers="op_headers" :items="[1]" disable-pagination hide-default-footer :mobile-breakpoint="100">
                                        <template v-slot:item="{ item }">
                                            <tr>
                                                <td>
                                                    <label for="qty">{{ selectedFirstOption.label }}</label>
                                                </td>
                                                <td>
                                                    <v-minusplusfield :min="0" :max="1000000" :value="getOrderOption(selectedFirstOption.id, 0)" @input="event => updateOrderOption(selectedFirstOption.option_id, selectedFirstOption.id, 0, 0, event)"></v-minusplusfield>
                                                </td>
                                                <td v-if="currentItem.id > 0" v-bind:class="{'cell-qty': getOrderOption(selectedFirstOption.id, 0, 'qty_not_bought') > 0}">
                                                    <v-minusplusfield :min="0" :max="1000000" :value="getOrderOption(selectedFirstOption.id, 0, 'qty_not_bought')" @input="event => updateOrderOption(selectedFirstOption.option_id, selectedFirstOption.id, 0, 0, event, 'qty_not_bought')"></v-minusplusfield>
                                                </td>
                                                <td v-if="currentItem.id > 0" v-bind:class="{'cell-qty': getOrderOption(selectedFirstOption.id, 0, 'qty_not_instore') > 0}">
                                                    <v-minusplusfield :min="0" :max="1000000" :value="getOrderOption(selectedFirstOption.id, 0, 'qty_not_instore')" @input="event => updateOrderOption(selectedFirstOption.option_id, selectedFirstOption.id, 0, 0, event, 'qty_not_instore')"></v-minusplusfield>
                                                </td>
                                            </tr>
                                        </template>
                                    </v-data-table>
                                </v-flex>
                            </v-layout>
                        </div>
                        <ul class="product_option list-inline-2" v-else>
                            <li class="number-picker single">
                                <label for="qty">Số lượng</label>
                                
                                <v-data-table :headers="op_headers" :items="[1]" disable-pagination hide-default-footer :mobile-breakpoint="100">
                                    <template v-slot:item="{ item }">
                                        <tr>
                                            <td>
                                                
                                            </td>
                                            <td>
                                                <v-minusplusfield :min="0" :max="1000000" :value="getOrderOption(0, 0)" @input="event => updateOrderOption(0, 0, 0, 0, event)"></v-minusplusfield>
                                            </td>
                                            <td v-if="currentItem.id > 0" v-bind:class="{'cell-qty': getOrderOption(0, 0, 'qty_not_bought') > 0}">
                                                <v-minusplusfield :min="0" :max="1000000" :value="getOrderOption(0, 0, 'qty_not_bought')" @input="event => updateOrderOption(0, 0, 0, 0, event, 'qty_not_bought')"></v-minusplusfield>
                                            </td>
                                            <td v-if="currentItem.id > 0" v-bind:class="{'cell-qty': getOrderOption(0, 0, 'qty_not_instore') > 0}">
                                                <v-minusplusfield :min="0" :max="1000000" :value="getOrderOption(0, 0, 'qty_not_instore')" @input="event => updateOrderOption(0, 0, 0, 0, event, 'qty_not_instore')"></v-minusplusfield>
                                            </td>
                                        </tr>
                                    </template>
                                </v-data-table>
                            </li>
                        </ul>
                    </v-flex>
                    <v-flex lg12 v-if="currentItem.id > 0">
                        <v-text-field label="Admin note" v-model="currentItem.admin_note" class="input-group--focused"></v-text-field>
                    </v-flex>
                </v-layout>
              </v-container>
            </v-card-text>
            <v-card-actions>
              <v-spacer></v-spacer>
              <v-btn color="red darken-1 white--text" @click="dialogItem = false">Đóng</v-btn>
              <v-btn @click="placeOrder">Lưu lại</v-btn>
            </v-card-actions>
          </v-card>
        </v-dialog>
        <v-dialog v-model="multipleDialog" max-width="600px">
          <v-card>
            <v-card-title>
              <span class="title">Cập nhật đơn hàng</span>
            </v-card-title>
            <v-card-text>
              <v-container grid-list-md pa-0>
                <v-layout row wrap>
                    <v-flex lg6>
                        <v-autocomplete label="Trạng thái" v-model="multipleUpdate.status" :items="order_status" item-text="name" item-value="value" class="input-group--focused"></v-autocomplete>
                    </v-flex>
                    <v-flex lg6>
                        <v-autocomplete label="Trạng thái giao hàng" v-model="multipleUpdate.shipment_status" :items="order_shipment_status" item-text="name" item-value="value" class="input-group--focused"></v-autocomplete>
                    </v-flex>
                    <v-flex lg6>
                        <v-text-field label="Mã đơn" v-model="multipleUpdate.meimei_code" class="input-group--focused"></v-text-field>
                    </v-flex>
                    <v-flex lg6>
                        <v-text-field label="Mã đơn TQ" v-model="multipleUpdate.china_order_code" class="input-group--focused"></v-text-field>
                    </v-flex>
                    <v-flex lg6 mt-6>
                        <v-checkbox label="Tự động gắn mã đơn" v-model="multipleUpdate.generate_meimei_code" class="input-group--focused"></v-checkbox>
                    </v-flex>
                    <v-flex lg6>
                        <h-currency-input label="Tiền hàng (¥)" v-model="multipleUpdate.china_order_amount" class="input-group--focused" :decimal="1"></h-currency-input>
                    </v-flex>
                    <v-flex lg12>
                        <v-checkbox label="Cập nhật tất cả đơn hàng" v-model="multipleUpdate.is_update_all" class="input-group--focused"></v-checkbox>
                    </v-flex>
                    <v-flex lg12 v-if="!multipleUpdate.is_update_all">
                        <h4 class="red--text">Cập nhật {{ selected.length }} đơn hàng đã chọn.</h4>
                    </v-flex>
                </v-layout>
              </v-container>
            </v-card-text>
            <v-card-actions>
              <v-spacer></v-spacer>
              <v-btn color="red darken-1 white--text" @click="multipleDialog = false">Đóng</v-btn>
              <v-btn @click="bulkUpdateData">Lưu lại</v-btn>
            </v-card-actions>
          </v-card>
        </v-dialog>
    </v-container>
    </template>
    
    <script>
    import { mapState } from "vuex";
    import configs from "@/configs";
    import Filtering from "@/components/Filtering";
    import { display_color } from "@/commons/formater";
    import { sendErrorNotice } from '@/commons/utils'
    import PlusMinusField from "@/components/PlusMinusField.vue";
    import _ from "lodash";
    
    export default {
        components: {
            "hpo-filter": Filtering,
            'v-minusplusfield': PlusMinusField
        },
        data() {
            return {
                viewName: "order_list",
                dialogItem: false,
                display_color: display_color,
                headers: [
                    {
                        text: "ID",
                        value: "id",
                        filterable: true,
                        dataType: configs.DATA_TYPE["Number"]
                    },
                    {
                        text: "Mã đơn",
                        value: "meimei_code",
                        quickSearch: true,
                        filterable: true,
                        dataType: configs.DATA_TYPE["String"]
                    },
                    {
                        text: "Mã đơn TQ",
                        value: "china_order_code",
                        quickSearch: true,
                        filterable: true,
                        dataType: configs.DATA_TYPE["String"]
                    },
                    {
                        text: "Ngày tạo",
                        value: "orders.created_at",
                        filterable: true,
                        dataType: configs.DATA_TYPE["Date"]
                    },
                    {
                        text: "Hình ảnh",
                        value: "path",
                        filterable: false,
                        dataType: configs.DATA_TYPE["String"]
                    },
                    {
                        text: "Họ tên",
                        value: "customer_first_name",
                        quickSearch: true,
                        filterable: true,
                        dataType: configs.DATA_TYPE["String"]
                    },
                    {
                        text: "Trạng thái",
                        value: "status",
                        filterable: true,
                        values: configs.ORDER_STATUS,
                        dataType: configs.DATA_TYPE["Enum"]
                    },
                    {
                        text: "Tình trạng",
                        value: "shipment_status",
                        filterable: true,
                        values: configs.ORDER_SHIPMENT_STATUS,
                        dataType: configs.DATA_TYPE["Enum"]
                    },
                    {
                        text: "Sản phẩm",
                        value: "name",
                        filterable: true,
                        quickSearch: true,
                        dataType: configs.DATA_TYPE["String"]
                    },
                    {
                        text: "Thuộc tính",
                        value: "options",
                        filterable: false,
                        sortable: false,
                        dataType: configs.DATA_TYPE["String"]
                    },
                    {
                        text: "Tổng tiền",
                        value: "total",
                        filterable: true,
                        align: "end",
                        dataType: configs.DATA_TYPE["Number"]
                    },
                    {
                        text: "Admin note",
                        value: "admin_note",
                        filterable: true,
                        quickSearch: true,
                        dataType: configs.DATA_TYPE["String"]
                    },
                    {
                        text: "",
                        value: "",
                        align: "center",
                        sortable: false,
                        filterable: false
                    }
                ],
                order_status: configs.ORDER_STATUS,
                order_shipment_status: configs.ORDER_SHIPMENT_STATUS,
                pagination: _.cloneDeep(configs.PAGINATION),
                items_per_page: _.cloneDeep(configs.ITEMS_PER_PAGE),
                filterConditions: [],
                quickFilterConditions: [],
                requireRules: [v => !!v || "Trường dữ liệu không được để trống."],
                selectedFirstOption: {},
                order_options: [],
                selectedItemList: null,
                isUpdateProp: false,
                selected: [],
                multipleDialog: false,
                multipleUpdate: {}
            };
        },
        watch: {
            pagination: {
                handler: function (val, oldVal) {
                    let filterConditions = this.$store.state.commons.filterConditions;
                    this.filterConditions = !_.isEmpty(filterConditions) ? filterConditions[this.viewName] : []
                    this.filter_data();
                },
                deep: true
            },
            selectedProduct() {
                if (this.selectedProduct) {
                    this.selectedFirstOption = this.selectedProduct.options && this.selectedProduct.options.length > 0 ? this.selectedProduct.options[0].option_values[0] : {};
                }
            },
            currentPath() {
                this.filter_data();
            }
        },
        computed: {
            ...mapState({
                items: state => state.orders.all.data,
                total_rows: state => state.orders.all.total,
                loading: state => state.orders.loading,
                currentItem: (state) => state.orders.selected,
                customers: state => state.users.all.data,
                products: state => state.products.all.data,
                selectedProduct: state => state.products.selected,
            }),
            role_list() {
                return _.filter(configs.ROLES, (p) => {return p.value == configs.ROLE_TYPE.Customer});
            },
            totalQty() {
                return _.sumBy(this.order_options, "value");
            },
            filter_headers() {
                return this.headers.concat([{
                        text: "Mã sản phẩm",
                        value: "product_code",
                        filterable: true,
                        quickSearch: true,
                        dataType: configs.DATA_TYPE["String"]
                    },]);
            },
            filter_param() {
                let param = {
                    pagination: this.pagination,
                    filter: [...this.filterConditions],
                    quickFilter: this.quickFilterConditions
                };
                
                if(this.currentPath && this.currentPath.includes('don-xuat')) {
                    param.filter.push({column: 'order_type', value: 1, condition: "equal"});
                }
                else {
                    param.filter.push({column: 'order_type', value: 1, condition: "does_not_equal"});
                }
                return param;
            },
            order_type() {
                return this.currentPath.includes('don-xuat') ? 1: 0;
            },
            currentPath() {
                return this.$route.path;
            },
            op_headers() {
                let tmp = [
                    {
                        text: "Thuộc tính"
                    },
                    {
                        text: "SL đặt"
                    }
                ];
                if (this.currentItem.id > 0) {
                    tmp.push({
                        text: "SL mua thiếu"
                    });
                    tmp.push({
                        text: "SL về thiếu"
                    });
                }
                return tmp;
            }
        },
        methods: {
            add_date_range_filter() {
                if(this.filterConditions.length == 0) {
                    let start_date = new URL(location.href).searchParams.get('start_date');
                    let end_date = new URL(location.href).searchParams.get('end_date');
                    if(start_date || end_date) {
                        _.remove(this.filterConditions, {'column': 'created_at'})
                    }
                    if(start_date) {
                        this.filterConditions.push({column: 'created_at', value: start_date, condition: "d_greater_than_or_equal"});
                    }
                    if(end_date) {
                        this.filterConditions.push({column: 'created_at', value: end_date, condition: "d_less_than_or_equal"});
                    }
                }
            },
            filter_data: function () {
                this.add_date_range_filter();
                this.$store.dispatch("orders/getList", this.filter_param);
                this.selected = [];
            },
            applyFilter(filterConditions) {
                let sortBy = this.pagination.sortBy
                let sortDesc = this.pagination.sortDesc
                this.pagination = configs.PAGINATION;
                this.pagination.sortBy = sortBy;
                this.pagination.sortDesc = sortDesc;
                this.filterConditions = filterConditions;
                this.filter_data();
            },
            quickFilter(filterConditions) {
                this.quickFilterConditions = filterConditions;
                this.filter_data();
            },
            openItem: function (item = {}) {
                this.order_options = [];
                if(!item.id) {
                    this.$store.commit("orders/setDetail", {'id': item.id});
                    this.selectedItemList = null;
                }
                else {
                    this.$store.dispatch("orders/getDetail", item.id).then((ret) => {
                        this.selectedFirstOption = ret.product_detail.options && ret.product_detail.options.length > 0 ? ret.product_detail.options[0].option_values[0] : {};
                        for (let i = 0; i < ret.options.length; i++) {
                            const element = ret.options[i];
                            let ops = element['option_id'] ? element['option_id'].split(',') : []
                            let vals = element['option_value_id'] ? element['option_value_id'].split(',') : []
                            this.order_options.push({
                                'id': element.id,
                                'product_id': ret.product_detail.id,
                                'order_id': ret.id,
                                'price': ret.product_detail.price,
                                'first_op_id': ops.length > 0 ? Number(ops[0]) : 0, 
                                'first_id': vals.length > 0 ? Number(vals[0]) : 0, 
                                'last_op_id': ops.length > 1 ? Number(ops[1]) : 0, 
                                'last_id': vals.length > 1 ? Number(vals[1]) : 0, 
                                'value': Number(element['qty']),
                                'qty_not_bought': Number(element['qty_not_bought']),
                                'qty_not_instore': Number(element['qty_not_instore']),
                            });
                    }
                    });
                    this.selectedItemList = item;
                }
                if(item.product_id > 0) {
                    this.$store.dispatch("products/getDetail", item.product_id);
                }
                else {
                    this.$store.commit("products/setDetail", {data: {}});
                }
                this.dialogItem = true;
            },
            deleteItem: function(id) {
                window.getApp.$emit('REQUEST_DELETE_DATA', id);
            },
            editItem() {
                this.$store.dispatch("orders/setDetail", {
                    'data': {...this.currentItem},
                    'id': this.currentItem.id
                });
                this.dialogItem = false;
            },
            getCustomerText(item) {
                return `${item.phone} - ${item.first_name}`
            },
            getProductText(item) {
                return `${item.product_code} - ${item.name}`
            },
            onSelectedProduct() {
                if(this.currentItem.product_id > 0) {
                    this.$store.dispatch("products/getDetail", this.currentItem.product_id);
                }
                else {
                    this.$store.commit("products/setDetail", {data: {}});
                }
            },
            updateOrderOption(first_op_id, first_opvl_id, last_op_id, last_opvl_id, value, prop = 'value') {
                let item = _.find(this.order_options, {'first_op_id': first_op_id, 'first_id': first_opvl_id, 'last_op_id': last_op_id, 'last_id': last_opvl_id });
                if (item) {
                    item[prop] = Number(value);
                }
                else {
                    item = {'first_op_id': first_op_id, 'first_id': first_opvl_id, 'last_op_id': last_op_id, 'last_id': last_opvl_id };
                    item[prop] = Number(value);
                    this.order_options.push(item);
                }
            },
            getOrderOption(first_id, last_id, prop='value') {
                let item = _.find(this.order_options, {'first_id': first_id, 'last_id': last_id });
                return item ? item[prop] : 0;
            },
            getFirstOptionQty(first_id) {
                return _.sumBy(this.order_options, (p) => {return p.first_id == first_id ? p.value : 0});
            },
            placeOrder() {
                if(this.totalQty == 0 && (this.isUpdateProp || !this.currentItem.id)) {
                    sendErrorNotice('Hãy chọn số lượng sản phẩm cần mua.');
                    return;
                }
                if(!this.currentItem.id) {
                    this.$store.dispatch("orders/setDetail", {data:{
                        product_id: this.selectedProduct.id,
                        customer_id: this.currentItem.customer_id,
                        qty: this.totalQty,
                        price: this.selectedProduct.price,
                        order_note: '',
                        multipleOptions: this.order_options,
                        sub_total: this.totalQty * this.selectedProduct.price,
                        total: this.totalQty * this.selectedProduct.price,
                    }});
                }
                else {
                    this.$store.dispatch("orders/setDetail", {data:{
                        ...this.currentItem,
                        action: this.isUpdateProp ? 'update_options' : '',
                        product_id: this.selectedItemList.product_id,
                        customer_id: this.selectedItemList.customer_id,
                        qty: this.totalQty,
                        price: this.selectedItemList.price,
                        multipleOptions: this.order_options,
                        sub_total: this.totalQty * this.selectedProduct.price,
                        total: this.totalQty * this.selectedProduct.price,
                    },
                    id: this.currentItem.id});
                }
                
                this.dialogItem = false;
            },
            bulkUpdateData() {
                let params = {filter: [...this.filterConditions], quickFilter: this.quickFilterConditions}
                params.filter.push({column: 'status', value: ['da_mua_hang', 'khach_huy_don', 'admin_huy_don'], condition: "not_in"})
                this.$store.dispatch("orders/setDetail", {data:{
                    ...this.multipleUpdate,
                    order_ids: _.map(this.selected, "id"),
                    action: 'multiple_update',
                    filter: params
                },
                id: 99999999999});
                this.multipleDialog = false;
                this.selected = [];
            },
            exportExcel() {
                this.$store.dispatch("orders/export_order", this.filter_param);
            },
            exportExcelBuy() {
                this.filter_param.filter.push({column: 'status', value: ['chua_mua_hang', 'dat_thieu'], condition: "in"})
                this.$store.dispatch("orders/export_order_to_buy", this.filter_param);
            },
        },
        mounted() {
            this.$store.dispatch("users/getList", {filter: [{column: 'role', value: configs.ROLE_TYPE.Customer, condition: "equal"}]});
            this.$store.dispatch("products/getList", {filter: [{column: 'is_active', value: 1, condition: "equal"}, {column: 'pro_type', value: 0, condition: "equal"}]});
            this.$root.$emit('REQUEST_ROOT_OPTION', {});
            this.$root.$on("REQUEST_CREATE_DATA", this.openItem);
            this.$root.$on("REQUEST_REFRESH_DATA", this.filter_data);
            this.$root.$on("REQUEST_SAVE_DATA", () => {this.multipleDialog = true; this.multipleUpdate = {}});
            this.$root.$on("CONFIRMED_REMOVE_DATA", id => {
                this.$store.dispatch("orders/removeDetail", id);
            });
        },
        beforeDestroy() {
            this.$root.$off("REQUEST_CREATE_DATA", this.openItem);
            this.$root.$off("REQUEST_REFRESH_DATA", this.filter_data);
            this.$root.$off("REQUEST_SAVE_DATA");
            this.$root.$off("CONFIRMED_REMOVE_DATA");
        }
    };
    </script>
<style scoped>
.row-qty {
    background-color: rgb(250, 235, 215) !important;
}
.cell-qty {
    background-color: rgb(249, 131, 131) !important;
}
</style>